import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { afterItems, beforeItems } from '../data/transformation';
export function ComparisonSection() {
  return <section aria-labelledby="comparison-title" className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-38" data-mp="39d6fzrg84hec">
      <Reveal className="mx-auto max-w-content" data-id="element-39" data-mp="34f4wx6issi2v">
        <div className="mx-auto mb-12 max-w-3xl text-center" data-id="element-40" data-mp="2zgbjtf7fat38">
          <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-41" data-mp="2zhwa2smpfpva">
            IL COSTO DI PARTIRE DA ZERO
          </p>
          <h2 id="comparison-title" className="text-3xl font-extrabold leading-[1.1] tracking-tight text-brand-primary md:text-4xl" data-id="element-42" data-mp="2qf3kqux31o83">
            Ogni Lezione da Improvvisare, o Ogni Unità Già Pronta.
          </h2>
        </div>
        <div className="overflow-hidden rounded-[20px] border border-brand-sand bg-brand-alt shadow-[0_14px_40px_rgba(11,60,93,0.08)]" data-id="element-43" data-mp="om5xdem2rnuj">
          <div className="grid md:grid-cols-2" data-id="element-44" data-mp="3aeuwti2y2upg">
            <Comparison eyebrow="IL VECCHIO MODO DI INSEGNARE MOTORIA" title="PRIMA" items={beforeItems} positive={false} data-id="element-45" data-mp="3ah7ctpp56uzv" />
            <Comparison eyebrow="IL CURRICOLO PRONTO ALL’USO" title="CON EDUCAZIONE FISICA PRONTA" items={afterItems} positive data-id="element-46" data-mp="30irk5iagvdo9" />
          </div>
          <div className="border-t border-brand-sand bg-brand-cream px-6 py-4 text-center text-xs italic text-brand-gray" data-id="element-47" data-mp="3t7p0hfv4b0ed">
            Un sistema motorio completo: prepari meno e insegni con più sicurezza.
          </div>
        </div>
        <div className="mt-10 flex justify-center" data-id="element-48" data-mp="3oecdfa6371nq">
          <CTAButton className="w-full max-w-md md:w-auto" data-id="element-49" data-mp="3od19998qbrw3" />
        </div>
      </Reveal>
    </section>;
}
interface ComparisonProps {
  eyebrow: string;
  title: string;
  items: string[];
  positive: boolean;
}
function Comparison({
  eyebrow,
  title,
  items,
  positive
}: ComparisonProps) {
  const Icon = positive ? CheckIcon : XIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'bg-brand-cream md:border-l md:border-brand-sand' : 'bg-[#F4F5F6]'}`} data-id="element-50" data-mp="pm6gk6s84pfy">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-51" data-mp="kmk2jv4kn563">
        <div data-id="element-52" data-mp="gm9xqlsimkst">
          <p className={`text-[10px] font-extrabold uppercase tracking-[0.16em] ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} data-id="element-53" data-mp="gmjdlgjujbks">
            {eyebrow}
          </p>
          <h3 className="mt-2 font-display text-xl font-bold tracking-tight text-brand-primary md:text-2xl" data-id="element-54" data-mp="6voq68uv65xr">
            {title}
          </h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-teal text-white shadow-sm' : 'bg-white text-brand-gray'}`} data-id="element-55" data-mp="1xdjg6zv8bjr">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-56" data-mp="3p10c1wk2q7en" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-57" data-mp="3k41hxe0eu0gg">
        {items.map(item => <li key={item} className="flex items-start gap-3 rounded-[16px] bg-white/70 px-3 py-3" data-id="element-58" data-mp="1zl7kceoh445h">
            <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-teal/15 text-brand-teal' : 'bg-black/5 text-brand-gray'}`} data-id="element-59" data-mp="24j9b7ls557ri">
              <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-60" data-mp="2dkpdf68sy3kn" />
            </span>
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-61" data-mp="1guq59cwkd72l">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}